import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  wallets: {
    data: [],
    meta: {
      total: 0,
    },
  },
  error: null,
};

export const fetchWalletBalance = createAsyncThunk(
  "wallet/fetchBalance",
  async ({ page = 0, limit = 10, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get("/users/wallet", {
        params: { page: page + 1, limit },
      });
      return { data: response.data.data.items, meta: response.data.data.meta };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    resetWallet: (state) => {
      state.wallets = initialState.wallets;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWalletBalance.pending, (state) => {
        state.fetchLoading = true;
      })
      .addCase(fetchWalletBalance.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.wallets = action.payload;
        state.error = null;
      })
      .addCase(fetchWalletBalance.rejected, (state, action) => {
        state.fetchLoading = false;
        state.error = action.payload?.error || null;
      });
  },
});

export const { resetWallet } = walletSlice.actions;
export default walletSlice.reducer;
